<script lang="ts">
  import clsx from 'clsx'

  export let values: string[] = []
  export let value: string
  export let label
  $: canPlus = values.indexOf(value) < values.length - 1
  $: canMinus = values.indexOf(value) > 0

  function onPlus() {
    let currentIndex = values.indexOf(value)
    if (currentIndex < values.length - 1) {
      value = values[currentIndex + 1]
    }
  }

  function onMinus() {
    let currentIndex = values.indexOf(value)
    if (currentIndex > 0) {
      value = values[currentIndex - 1]
    }
  }
</script>

<li class="pl-3 w-full">
  <div class={clsx('flex flex-col justify-start gap-2 w-full')}>
    <span>{label}</span>
    <div class="flex gap-2 items-center">
      <button
        on:click|preventDefault|stopPropagation={(e) => onMinus()}
        class={clsx(
          canMinus ? 'bg-white' : 'bg-gray-500 cursor-default',
          'w-6 h-6 font-semibold rounded-full border border-white/35  text-black text-xl flex items-center justify-center content-center',
        )}>-</button
      >
      <p class="min-w-8 text-center">x{parseFloat(value)}</p>
      <button
        on:click|preventDefault|stopPropagation={(e) => onPlus()}
        class={clsx(
          canPlus ? 'bg-white' : 'bg-gray-500 cursor-default',
          'w-6 h-6 font-semibold rounded-full border border-white/35  text-black text-xl flex items-center justify-center content-center',
        )}>+</button
      >
    </div>
  </div>
</li>
